import React from "react";
import { Table, TableHead, TableBody, TableCell, TableRow, Grid, Grow, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const tableCellStyle = { color: "#222" };

export default function EquipmentTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={10} sm={6} md={8}>
                <div className="masterDataTable">
                    <Table aria-label="simple table">
                        <TableHead sx={{ position: "sticky", top: 0 }}>
                            <TableRow>
                                <TableCell align="center">{t("Line")} </TableCell>
                                <TableCell align="center">{t("MainEquipmentCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentTypeName")} </TableCell>
                                <TableCell align="center">{t("CostCenterCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentTypeCode")} </TableCell>
                                <TableCell align="center">{t("AreaCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentBrand")} </TableCell>
                                <TableCell align="center">{t("EquipmentModel")} </TableCell>
                                <TableCell align="center">{t("SapCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentBarcodeContent")} </TableCell>
                                <TableCell align="center">{t("EquipmentWarrantyStart")} </TableCell>
                                <TableCell align="center">{t("EquipmentWarrantyEnd")} </TableCell>
                                <TableCell align="center">{t("Priority")} </TableCell>
                                <TableCell align="center">{t("FreeText") + "1"} </TableCell>
                                <TableCell align="center">{t("FreeText") + "2"} </TableCell>
                                <TableCell align="center">{t("FreeText") + "3"} </TableCell>
                                <TableCell align="center">{t("FreeText") + "4"} </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.equipmentExcel.map((row, index) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell className="fontColor" align="center">
                                        {index + 2}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {" "}
                                        {row.mainEquipmentCode}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.equipmentCode}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.equipmentType}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.costCenterCode}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.equipmentType}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.areaGroup}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.brand}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.model}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.sapCode}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.barcodeContent}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.warrantyStart}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.warrantyEnd}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.priority}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.freeText1}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.freeText2}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.freeText3}{" "}
                                    </TableCell>
                                    <TableCell className="fontColor" align="center">
                                        {row.freeText4}{" "}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={1} sm={3} md={4}>
                {props.warnings.length > 0 && props.equipmentExcel.length > 0 ? (
                    <>
                        <Grid item md={1}></Grid>
                        <Grid item md={11}>
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <TableContainer component={Paper} className="warningTable">
                                    <Table sx={{ minWidth: 200 }} aria-label="simple table">
                                        <TableHead sx={{ position: "sticky", top: 0 }}>
                                            <TableRow>
                                                <TableCell align="center">{t("Line")}</TableCell>
                                                <TableCell align="center">{t("Warnings")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.warnings.map((row) => (
                                                <TableRow>
                                                    <TableCell sx={{maxWidth: 200}} className="fontColor" align="center">
                                                        {row.rowNumber}
                                                    </TableCell>
                                                    <TableCell size="small" className="fontColor" align="center">
                                                        {row.message}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grow>
                        </Grid>
                    </>
                ) : null}
            </Grid>{" "}
            {/*Empty grid for alignment*/}
        </Grid>
    );
}
